"use strict";

import template from "./readonly.jade";
import BaseController from "./base.controller";

class BewertungReadonlyController extends BaseController {
  /*@ngInject*/
  constructor(Katalog, ParameterUtils) {
    super(Katalog, ParameterUtils);
  }
}

export default {
  bindings: {
    parameter: "=",
    key: "@",
  },
  template: template(),
  controller: BewertungReadonlyController,
  controllerAs: "vm",
};
